let initialized = false;
export const initParameterLinks = () => {
    if (initialized) {
        return;
    }
    initialized = true;
    const search = window.location.search;
    if (!search) {
        return;
    }
    const params = new URLSearchParams(search.substring(1));
    document.querySelectorAll('a[href]').forEach((link) => {
        const linkHref = link.getAttribute('href');
        if (!linkHref || linkHref.startsWith('#') || linkHref.startsWith('tel:')) {
            return;
        }
        if (linkHref.startsWith('http') &&
            !linkHref.startsWith(window.location.protocol + '//' + window.location.hostname)) {
            return;
        }
        const linkParts = linkHref.split('?', 2);
        if (linkParts.length === 1) {
            link.href = linkHref + search;
            return;
        }
        const linkUrlParams = new URLSearchParams(linkParts[1]);
        for (const [key, value] of params) {
            if (!linkUrlParams.has(key)) {
                linkUrlParams.set(key, value);
            }
        }
        link.href = linkParts[0] + '?' + linkUrlParams.toString();
    });
};
